import { VariantProps } from 'class-variance-authority';
import clsx from 'clsx';
import { ReactNode, forwardRef } from 'react';
import { variants } from './variants';
import { cn } from '../../lib/_utils/cn';
import Spinner from '../spinner/Spinner';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof variants> & {
    variant?: string;
    size?: string;
    outline?: boolean;
    disabled?: boolean;
    fullwidth?: boolean;
    icon_left?: string | ReactNode;
    icon_right?: string | ReactNode;
    loading?: boolean;
  };

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      variant = 'primary',
      size,
      fullwidth,
      outline,
      icon_left,
      icon_right,
      loading,
      disabled,
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      className={`${cn(variants({ variant, size, outline, fullwidth }), className)}`}
      disabled={disabled}
      {...rest}
    >
      {loading && <Spinner variant={variant} outline={outline} size={size} disabled={disabled} />}
      <span
        className={`flex items-center justify-center ${clsx('transition', {
          'opacity-0': loading,
          'opacity-100': !loading,
        })}`}
      >
        {!!icon_left && <span className={`mr-[6px] inline-block`}>{icon_left}</span>}
        <span>{children}</span>
        {!!icon_right && <span className={`ml-[6px] inline-block`}>{icon_right}</span>}
      </span>
    </button>
  )
);

Button.displayName = 'Button';

export { Button };
export type { ButtonProps };
